import type { ClassCategory } from '../../types'
import csMark from '../../assets/illustrations/subjects/cs.webp'
import designMark from '../../assets/illustrations/subjects/design.webp'
import businessMark from '../../assets/illustrations/subjects/business.webp'
import englishMark from '../../assets/illustrations/subjects/english.webp'
import islamicMark from '../../assets/illustrations/subjects/islamic.webp'
import webMark from '../../assets/illustrations/subjects/web.webp'
import appMark from '../../assets/illustrations/subjects/app.webp'
import arabicMark from '../../assets/illustrations/subjects/arabic.webp'
import hausaMark from '../../assets/illustrations/subjects/hausa.webp'
import catTechnology from '../../assets/illustrations/categories/technology.webp'
import catDesign from '../../assets/illustrations/categories/design.webp'
import catBusiness from '../../assets/illustrations/categories/business.webp'
import catSkills from '../../assets/illustrations/categories/skills.webp'
import catPersonal from '../../assets/illustrations/categories/personal-development.webp'
import catLanguages from '../../assets/illustrations/categories/languages.webp'
import catQuran from '../../assets/illustrations/categories/quran.webp'
import catIslamic from '../../assets/illustrations/categories/islamic-sciences.webp'
import catHistory from '../../assets/illustrations/categories/history.webp'

// QURAN is left out on purpose (founder, 7 Oct 2026): not ready yet; its class is hidden. Add it back here when ready.
export const CATEGORY_ORDER: ClassCategory[] = ['TECHNOLOGY', 'DESIGN', 'BUSINESS', 'SKILLS_ACQUISITION', 'PERSONAL_DEVELOPMENT', 'LANGUAGE', 'ISLAMIC_SCIENCES', 'HISTORY']

export const SUBJECT_ART = {
    web: webMark, app: appMark, cs: csMark, design: designMark,
    business: businessMark, english: englishMark, islamic: islamicMark,
    arabic: arabicMark, hausa: hausaMark,
} as const

const bundledPaths = new Set([
    ...Object.values(SUBJECT_ART),
    ...Object.keys(SUBJECT_ART).map(name => `/src/assets/illustrations/subjects/${name}.webp`),
])

/** Exact local asset identity survives Vite's production hashing, without guessing remote art. */
export function isSubjectArt(url: string): boolean {
    if (bundledPaths.has(url)) return true
    try {
        const origin = typeof window === 'undefined' ? 'https://dhtn.local' : window.location.origin
        const resolved = new URL(url, origin)
        return resolved.origin === origin && bundledPaths.has(resolved.pathname)
    } catch {
        return false
    }
}

/** One painting per catalog row (Codex sheets 6 and 7, 6 Oct 2026); also the fallback cover of a class with no picture. */
export const CATEGORY_ART: Partial<Record<ClassCategory, string>> = {
    TECHNOLOGY: catTechnology,
    DESIGN: catDesign,
    BUSINESS: catBusiness,
    SKILLS_ACQUISITION: catSkills,
    PERSONAL_DEVELOPMENT: catPersonal,
    LANGUAGE: catLanguages,
    QURAN: catQuran,
    ISLAMIC_SCIENCES: catIslamic,
    HISTORY: catHistory,
}
